import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import About from './pages/About.vue'
import Privacy from './pages/Privacy.vue'
import Terms from './pages/Terms.vue'
import Banks from './pages/Banks.vue'
import WidgetDemo from './pages/WidgetDemo.vue'
import Account from './pages/Account.vue'
import AccountPersonal from './pages/AccountPersonal.vue'
import AccountPayment from './pages/AccountPayment.vue'
import AccountDone from './pages/AccountDone.vue'
import { i18n } from './language/i18n'
import store from './store'
import { sessionStatuses } from './constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang',
      component: { render(c) { return c('router-view') } },
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
          meta: {
            title: 'Tilisy',
            description: 'Easy & secure way to download bank account data through Open Banking / PSD2 APIs'
          }
        },
        {
          path: 'widget',
          component: WidgetDemo,
          meta: {
            title: 'Tilisy Widget Demo',
            description: 'Easy & secure way to download bank account data through Open Banking / PSD2 APIs'
          }
        },
        {
          path: 'banks',
          name: 'banks',
          component: Banks
        },
        {
          path: 'account',
          name: 'account',
          component: Account,
          meta: { hideFooter: true, requiresAuth: true },
          redirect: {
            name: 'accountPersonal'
          },
          children: [
            {
              path: '',
              name: 'accountPersonal',
              component: AccountPersonal,
              meta: { hideFooter: true }
            },
            {
              path: 'payment',
              name: 'accountPayment',
              component: AccountPayment,
              meta: { hideFooter: true }
            },
            {
              path: 'done',
              name: 'accountDone',
              component: AccountDone,
              meta: { hideFooter: true }
            }
          ]
        },
        {
          path: 'about',
          name: 'about',
          component: About
        },
        {
          path: 'privacy',
          name: 'privacy',
          component: Privacy
        },
        {
          path: 'terms',
          name: 'terms',
          component: Terms
        }
      ]
    }
  ],
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const checkIsAuth = async (to, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    await store.dispatch('auth/getSessionStatus')

    const sessionStatus = store.getters['auth/sessionStatus']

    if (sessionStatus === sessionStatuses.Authorized) {
      next()
    } else {
      router.push({ query: { expired: true } })
      next({
        name: 'banks'
      })
    }
  } else {
    next()
  }
}

const checkLanguage = (to, next) => {
  const language = to.params.lang

  if (!Object.keys(i18n.messages).includes(language) && to.path !== '/bank-login/') {
    return next('en')
  }

  if (i18n.locale !== language) {
    i18n.locale = language
  }
  next()
}

router.beforeEach((to, _from, next) => {
  checkLanguage(to, next)
  checkIsAuth(to, next)
})

export default router
